import {
  COLLECTIONS_IMPORT_ITEMS_FROM_JSON_BEGIN,
  COLLECTIONS_IMPORT_ITEMS_FROM_JSON_SUCCESS,
  COLLECTIONS_IMPORT_ITEMS_FROM_JSON_FAILURE,
  COLLECTIONS_IMPORT_ITEMS_FROM_JSON_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function importItemsFromJson(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_IMPORT_ITEMS_FROM_JSON_BEGIN,
    });
    const { projectId, version, collectionName, formData } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/import-json`,
        formData,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_IMPORT_ITEMS_FROM_JSON_SUCCESS,
            data: res.data,
          });
          toast.success('Data Imported Successfully !');
          resolve(res.data);
        },
        (err) => {
          toast.error(`Failed To Import Data `);
          dispatch({
            type: COLLECTIONS_IMPORT_ITEMS_FROM_JSON_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissImportItemsFromJsonError() {
  return {
    type: COLLECTIONS_IMPORT_ITEMS_FROM_JSON_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_IMPORT_ITEMS_FROM_JSON_BEGIN:
      return {
        ...state,
        importItemsFromJsonPending: true,
        importItemsFromJsonError: null,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_JSON_SUCCESS:
      return {
        ...state,
        importItemsFromJsonPending: false,
        importItemsFromJsonError: null,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_JSON_FAILURE:
      return {
        ...state,
        importItemsFromJsonPending: false,
        importItemsFromJsonError: action.data.error,
      };

    case COLLECTIONS_IMPORT_ITEMS_FROM_JSON_DISMISS_ERROR:
      return {
        ...state,
        importItemsFromJsonError: null,
      };

    default:
      return state;
  }
}
